import { render, staticRenderFns } from "./Tms.vue?vue&type=template&id=56cf4ce4&scoped=true&"
import script from "./Tms.vue?vue&type=script&lang=js&"
export * from "./Tms.vue?vue&type=script&lang=js&"
import style0 from "./Tms.vue?vue&type=style&index=0&id=56cf4ce4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cf4ce4",
  null
  
)

component.options.__file = "Tms.vue"
export default component.exports